<template>
    <span @click="onClick">
        <slot :formattedDate="formattedDate">
            <span>{{ formattedDate }}</span>
        </slot>
    </span>
</template>

<script>
    import { toStringDate } from '@superbet-group/web.lib.utilities';

    export default {
        name: 'DisplayDate',
        emits: ['click'],
        props: {
            date: {
                type: Date,
                required: true,
            },
            format: {
                type: String,
                required: false,
                default: 'dd.MM.',
            },
        },
        computed: {
            formattedDate() {
                return toStringDate(this.date, this.format);
            },
        },
        methods: {
            onClick() {
                this.$emit('click', this.date);
            },
        },
    };
</script>

<style scoped>

</style>
